export const strings = {
  title: 'طباعة الشهادات',
  subtitle: 'شهادات برنامج تدريبي، ومن صدرت لهم',
  downloadCertificates: 'تحميل الشهادات',
  downloadList: 'تحميل قائمة المستخدمين',
  selectAll: 'اختيار الكل',
  chooseProgram: 'اختر برنامجا لعرض من صدرت لهم شهاداته',
  empty: 'لا توجد شهادات مطابقة',
  actionFailed: 'تعذر إتمام العملية',
  fail: {
    page: 'تعذر تحميل صفحة طباعة الشهادات',
    list: 'تعذر تحميل قائمة الشهادات',
    print: 'تعذر طباعة الشهادة',
  },

  filter: {
    program: 'البرنامج التدريبي',
    from: 'من تاريخ',
    to: 'إلى تاريخ',
  },

  columns: {
    index: '#',
    username: 'اسم المستخدم',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    group: 'الإدارة',
    issuedOn: 'تاريخ الإصدار',
    expiresOn: 'تاريخ الانتهاء',
    daysLeft: 'المتبقي',
  },
}
